export const handleReCaptchaVerifyUtil = (
  useCallback: any,
  executeRecaptcha: any
) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useCallback(async (): Promise<string | undefined> => {
    if (!executeRecaptcha) {
      return;
    }
    try {
      const token = await executeRecaptcha("login");
      return token;
    } catch (e) {
      console.error(e);
      location.reload();
    }
  }, [executeRecaptcha]);
};
